
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 426.667 426.667"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M192 298.667h42.667v42.667H192z"}}),_c('path',{attrs:{"d":"M213.333 0C95.513 0 0 95.513 0 213.333s95.513 213.333 213.333 213.333 213.333-95.513 213.333-213.333S331.154 0 213.333 0zm0 388.053c-96.495 0-174.72-78.225-174.72-174.72s78.225-174.72 174.72-174.72c96.446.117 174.602 78.273 174.72 174.72 0 96.496-78.224 174.72-174.72 174.72z"}}),_c('path',{attrs:{"d":"M296.32 150.4c-10.974-45.833-57.025-74.091-102.858-63.117-38.533 9.226-65.646 43.762-65.462 83.384h42.667c2.003-23.564 22.729-41.043 46.293-39.04s41.043 22.729 39.04 46.293c-4.358 21.204-23.38 36.169-45.013 35.413-10.486 0-18.987 8.501-18.987 18.987v45.013h42.667v-24.32c45.12-11.635 72.565-57.312 61.653-102.613z"}})])
          )
        }
      }
    